import {
  Flex,
  ModelTripleToggle, Table, TextSort,
} from '@equifinance/shared';
import { DateFormatStringEnum, formatDateTime } from '@equifinance/shared/utils';
import { useCallback } from 'react';
import styled from 'styled-components';
import { Representative } from '../../../../../contexts/brokerages';
import { useCompanyContext } from '../../../../../contexts/company';
import { useTableStyles } from './BankDetails';
import { BrokerDetailGenericSection } from '../../../components/BrokerDetailGenericSection';
import LongContentCell from '../../../components/LongContentCell';

export const representativeRefName = 'representative-details';

const TripleToggleInputWrapper = styled(Flex)`
  align-items: center;
`;

export default function RepresentativeSection() {
  const { company: { representatives } } = useCompanyContext();

  const DirectorToggle = useCallback((representative: Representative) => {
    const index = representatives.map((e) => e.id).indexOf(representative?.id);

    return (
      <TripleToggleInputWrapper>
        <ModelTripleToggle
          id={`director-${representative?.id}`}
          field={`representatives[${index}].director`}
        />
      </TripleToggleInputWrapper>
    );
  }, [representatives]);

  const columns = [
    {
      name: 'First and last name',
      cell: (representative: Representative) => LongContentCell(representative.fullName || '-', `${representative.id}-fullname`),
      sortFunction: TextSort<Representative>('fullName'),
    },
    {
      name: 'Position',
      cell: (representative: Representative) => LongContentCell(representative.position || '-', `${representative.id}-position`),
      sortFunction: TextSort<Representative>('position'),
    },
    {
      name: 'Director',
      cell: (representative: Representative) => DirectorToggle(representative),
      sortFunction: TextSort<Representative>('director'),
    },
    {
      name: 'Shareholding',
      cell: (representative: Representative) => (representative.shareholdingPct ? `${representative.shareholdingPct * 100} %` : '-'),
      sortFunction: TextSort<Representative>('shareholdingPct'),
    },
    {
      name: 'Appointed on',
      cell: (representative: Representative) => (representative.appointedOn ? formatDateTime(representative.appointedOn, DateFormatStringEnum.DDMMYYYY) : '-'),
      sortFunction: TextSort<Representative>('appointedOn'),
    },
    {
      name: 'Resigned on',
      sortable: false,
      cell: (representative: Representative) => (representative.resignedOn ? formatDateTime(representative.resignedOn, DateFormatStringEnum.DDMMYYYY) : '-'),
      sortFunction: TextSort<Representative>('resignedOn'),
    },
  ];

  const tableStyles = useTableStyles();

  return (
    <BrokerDetailGenericSection
      id={representativeRefName}
      refName={representativeRefName}
      title="Representative"
      level={1}
    >
      <Table
        showSearch={false}
        columns={columns}
        data={representatives}
        styles={tableStyles}
      />
    </BrokerDetailGenericSection>
  );
}
